"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductInfoDialogProducts = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../../queries-net");
var _mappers = require("../mappers");
const getProductInfoDialogProducts = async ({
  graphQlUrl,
  productCodes,
  headers
}) => {
  const {
    products
  } = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.getProducts,
    url: graphQlUrl,
    variables: {
      productCodes
    },
    headers
  });
  return products ? (0, _mappers.mapProductsFromGql)(products) : [];
};
exports.getProductInfoDialogProducts = getProductInfoDialogProducts;